import * as angular from 'angular';
import { config } from 'angular/utils/config';
import { XmlUploader } from '../custom';

export interface BalancingGroupAssignmentResource
    extends ng.resource.IResourceClass<
            ng.resource.IResource<BalancingGroupDto>
        >,
        XmlUploader {
    get: ng.resource.IResourceMethod<
        ng.resource.IResource<BalancingGroupAssignmentDto>
    >;
    generateXml: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    uploadAsXML: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    save: ng.resource.IResourceMethod<
        ng.resource.IResource<BalancingGroupAssignmentDto>
    >;
}

function balancingGroupAssignmentResource(
    $resource: ng.resource.IResourceService
): BalancingGroupAssignmentResource {
    return <BalancingGroupAssignmentResource>$resource(
        config.monolithApi + '/balancing-group-assignment',
        {},
        {
            get: {
                method: 'GET',
                url: config.monolithApi + '/balancing-group-assignment/:name'
            },
            generateXml: {
                method: 'POST',
                url: config.monolithApi + '/balancing-group-assignment/as-xml'
            },
            uploadAsXML: {
                method: 'POST',
                url: config.monolithApi + '/balancing-group-assignment',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }
        }
    );
}

angular
    .module('app')
    .factory(
        'balancingGroupAssignmentResource',
        balancingGroupAssignmentResource
    );
